export const RouteTypes = [
  { id: 'EXTENSION', name: 'Ramal' },
  { id: 'SPECIFIC_EXTENSION', name: 'Ramal Específico' },
  { id: 'IVR', name: 'URA' },
  { id: 'QUEUE', name: 'Fila' },
  { id: 'RING_GROUP', name: 'Grupo de Toque' },
  { id: 'CONFERENCE', name: 'Conferência' },
  { id: 'CUSTOMIZED', name: 'Customizado' }
];
